import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import appInfo from './app-info';
import routes from './app-routes';
import TopNavLayout from 'layouts/top-nav-layout/top-nav-layout';


export default function Content() {
  return (
    <TopNavLayout title={appInfo.title}>
      <Switch>
        {routes.map(({ path, component }) => (
          <Route
            exact
            key={path}
            path={path}
            component={component}
          />
        ))}
        <Redirect to={'/overview'} />
      </Switch>
      
    </TopNavLayout>
  );
}
